import React from 'react';
import { SplitColorTitle } from '@/components/common/split-color-title';
import { Button, Typography } from '@/components/common';
import AppRoutes from '@/const/routes';
import { ContainerBase } from '../containers';

export const HeroAboutUs: React.FC = () => {
	const description = `Lowey Dannenberg has been delivering landmark results in complex
							cases for more than 50 years, having recovered billions of dollars
							for its clients in a wide range of cases involving just about
							every kind of corporate misconduct.`;
	return (
		<ContainerBase className="relative">
			<section className="lg:h-[399px] flex items-center lg:py-20 lg:px-[78px] ">
				<div className="flex flex-col lg:flex-row items-center lg:h-[239px]">
					<div className="w-full lg:w-2/5 lg:min-w-[520px] lg:border-r-2 lg:border-primary">
						<SplitColorTitle
							blackText="About"
							colorText="Us"
							textSize="custom-h1"
							className="text-[40px] lg:text-6xl font-bold  text-center lg:text-left"
						/>
						<SplitColorTitle
							blackText="Decades of"
							colorText="Justice"
							textSize="custom-h2"
							className="!text-2xl lg:!text-[32px] text-center lg:text-left"
						/>
						<div className="flex-1 lg:hidden mt-6">
							<Typography type="regular-20" className="!leading-[150%]">
								{description}
							</Typography>
						</div>
						<div className="flex flex-col-reverse lg:flex-row items-center gap-4 mt-10">
							<Button
								href={AppRoutes.LANDING_CASES}
								size="large"
								decoration="secondary"
								className="!w-full md:!w-[11.625rem] !px-0 order-2 md:order-none"
							>
								Explore All Cases
							</Button>
							<Button
								href={AppRoutes.CLIENTAPP_AUTH_SIGN_UP}
								size="large"
								decoration="primary"
								className="!w-full md:!w-[11.625rem] !px-0"
							>
								Get Started Today
							</Button>
						</div>
					</div>
					<div className="flex-1 pl-10 hidden lg:block">
						<Typography type="regular-20" className="!leading-[150%]">
							{description}
						</Typography>
					</div>
				</div>
			</section>
		</ContainerBase>
	);
};
